import "../../../assets/stylesheets/StartApplication/CAS/AddedPersonalSalesRecordToast.scss";

function AddedPersonalSalesRecordToast(props) {
  const closeToast = () => {
    props.closeToast();
  };
  return (
    <>
      <div
        id="psr_added_alert"
        className={
          props.showToast === true
            ? "show col-md-6 alert-item"
            : "d-none col-md-6 alert-item"
        }
        style={{ float: "right" }}
      >
        <div className="mm-toast-container">
          <div
            className="toast"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
          >
            <div className="wrapper">
              <div className="toast-header">
                <strong>
                  Your Personal{" "}
                  {props.hasNYRegs === false ? <>Sales</> : <>Production</>}{" "}
                  Record has been {props.addedSaved} successfully.
                </strong>
                <button
                  className="close"
                  type="button"
                  data-dismiss="toast"
                  aria-label="Close"
                  onClick={closeToast}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddedPersonalSalesRecordToast;
